import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "m25.707 22-9-9 .646-.646a.525.525 0 0 0 .084-.111c.058-.104.563-1.037.563-1.743C18 9.121 16.878 8 15.5 8S13 9.121 13 10.5h1c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5c0 .266-.165.7-.318 1.023a.81.81 0 0 1-.15.238L6.291 22h19.416zm-2.414-1H8.706L16 13.707 23.293 21z"
    })
  }));
};
export default SvgComponent;